/*=========================================================================================
  File Name: moduleAuth.js
  Description: Auth Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import actions from './apiActions.js'
import state from './apiState.js'
import mutations from './apiMutations.js'
import getters from './apiGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
